// src/services/initTokenPrices.js
// This file initializes the token prices on application startup

import tokenPriceStore from './tokenPriceStore';

/**
 * Initialize the token price service on application startup
 * This ensures the price store is ready when components need it
 */
export const initTokenPrices = () => {
  console.log('🚀 Initializing token price service on application startup');
  
  // Initialize the price store
  tokenPriceStore.initialize();
  
  // Set up default tokens to monitor based on your application needs
  // These are common tokens you might want to have prices for immediately
  const defaultTokensToMonitor = [

  ];
  
  // Add these tokens to be monitored
  tokenPriceStore.addTokensToMonitor(defaultTokensToMonitor);
  
  // You could trigger an initial price fetch in the background
  setTimeout(() => {
    tokenPriceStore.updateAllPrices();
  }, 1000);
  
  return tokenPriceStore;
};

// Auto-initialize the service when this file is imported
export default initTokenPrices();